'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

export const useEmbedScroll = () => {
    const path = usePathname();
    const firstRenderComplete = useRef(false);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        if (!firstRenderComplete.current) {
            firstRenderComplete.current = true;
            return;
        }

        window.parent.postMessage({ messageType: 'scroll', scroll: 'into-view' }, '*');
    }, [path]);
};
